import React, { useEffect, useRef, useState } from 'react';

import moment from 'moment';

import { useStylesMUI } from '../../../styles/home/style';
import { TemplateABM } from '../../atomic/templates/TemplateABM';
import { ValidatorInputField } from '../../atomic/atoms/Inputs';
import { required } from '../../../helpers/validations/validators';
import { useTotem } from '../../../hooks/useCases/useTotem';
import { MultiSearchValidatorGeneric } from '../../atomic/atoms/Select';
import { GenericModal } from '../../atomic/organisms/GenericModal';
import TableGeneric from '../../compartidos/abms/TableGeneric';
import { ButtonGeneric, ButtonGroupGeneric } from '../../atomic/atoms/Buttons';
import { GenericCheckboxTable } from '../../atomic/organisms/GenericTable';

const initModal = {
  open: false,
  value: '',
  title: '',
};

export const TotemRecepcionABM = () => {
  const classes = useStylesMUI();
  const componentRef = useRef();
  const totem = useTotem();

  const [modalRecepcionistas, setModalRecepcionistas] = useState(initModal);
  const [modalSolicitudes, setModalSolicitudes] = useState(initModal);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    totem.get.recepciones();
  }, []);

  return (
    <div className={classes.root}>
      <TemplateABM
        titles={{
          abm: 'Recepciones Totem',
          insert: 'Agregar Recepción',
          update: 'Modificar Recepción',
          delete: 'Eliminar Recepción',
        }}
        data={(data) => ({
          id: data?.id || '',
          descripcion: data?.descripcion || '',
          recepcionistas: data?.recepcionistas || [],
          solicitudesUsuarios: data?.solicitudesUsuarios || [],
        })}
        formStructure={({ formValues, handleInputChange, setearValor }) => [
          {
            Component: ValidatorInputField,
            variant: 'outlined',
            label: 'Descripcion',
            name: 'descripcion',
            value: formValues.descripcion,
            onChange: handleInputChange,
            validations: [required],
            grid: { xs: 12 },
          },
          {
            Component: MultiSearchValidatorGeneric,
            dataBody: (item) => ({
              id: item?.id,
              userName: item?.userName,
              email: item?.email,
              dni: item?.dni,
            }),
            formList: formValues.recepcionistas,
            setearValorForm: (value) => {
              setearValor('recepcionistas', value);
            },
            deleteValorForm: (id) => {
              setearValor(
                'recepcionistas',
                formValues.recepcionistas.filter((item) => item.id !== id),
              );
            },
            title: 'Seleccione Recepcionista',
            noChip: 'No se selecciono ningun recepcionista',
            chipLabel: (item) => `${item.userName} - DNI: ${item.dni}`,
            grid: { xs: 12 },

            searchProps: {
              label: 'Nombre Usuario | DNI | Email',
              endpoint: (inputValue) =>
                `TotemRecepcionistas/Usuarios?buscador=${inputValue}`,
              noOptionText: 'No se encuentra usuario',
              getOptionLabel: (option) =>
                `${option.userName.toUpperCase()} - DNI: ${option.dni} - ${
                  option.email
                }`,
              renderOption: (option) => (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  {`${option.userName.toUpperCase()} - DNI: ${option.dni} - ${
                    option.email
                  }`}
                </div>
              ),
            },
          },
        ]}
        dataTable={{
          list: totem.data.recepciones,
          columns: [
            {
              label: 'Descripcion',
              id: 'descripcion',
            },
            {
              label: 'Recepcionistas',
              customBody: (item) => (
                <ButtonGeneric
                  type="button"
                  text={`VER RECEPCIONISTAS (${item.recepcionistas.length})`}
                  disabled={item.recepcionistas.length === 0}
                  onClick={() => {
                    setModalRecepcionistas({
                      open: true,
                      value: item.recepcionistas,
                      title: `RECEPCIONISTAS - ${item.descripcion}`,
                    });
                  }}
                />
              ),
            },
            {
              label: 'Solicitudes Usuarios',
              customBody: (item) => (
                <ButtonGeneric
                  type="button"
                  text={`VER SOLICITUDES (${item.solicitudesUsuarios.length})`}
                  disabled={item.solicitudesUsuarios.length === 0}
                  onClick={() => {
                    setModalSolicitudes({
                      open: true,
                      value: item,
                      title: `SOLICITUDES USUARIOS - ${item.descripcion}`,
                    });
                  }}
                />
              ),
            },
          ],
        }}
        submit={(formValues, handleClose) => {
          const data = {
            id: formValues.id,
            descripcion: formValues.descripcion,
            recepcionistas: formValues.recepcionistas
              .map((item) => item.id)
              .join(','),
          };
          if (!!formValues.id)
            totem.update.recepcion(data, {
              ...formValues,
              solicitudesUsuarios: formValues.solicitudesUsuarios.filter(
                (item) =>
                  !formValues.recepcionistas.some((r) => r.id === item.idUser),
              ),
            });
          else totem.insert.recepcion(data, formValues);
          handleClose();
        }}
        deleteButton={(id, handleClose) => {
          totem.remove.recepcion(id);
          handleClose();
        }}
      />

      {modalRecepcionistas.open && (
        <GenericModal
          open={modalRecepcionistas.open}
          closeModal={() => {
            setModalRecepcionistas(initModal);
          }}
          title={modalRecepcionistas.title}
          gridStyle={{ textAlign: 'center', padding: '1em' }}
          maxWidth="sm"
        >
          <div style={{ border: '1px solid #ddd' }}>
            <TableGeneric
              ref={componentRef}
              data={modalRecepcionistas.value}
              withoutPagination
              align="center"
              colTitleStyle={{ fontSize: '1.2em' }}
              columns={[
                {
                  id: 'userName',
                  label: 'Nombre Usuario',
                },
                {
                  id: 'email',
                  label: 'Email',
                },
                {
                  id: 'dni',
                  label: 'DNI',
                },
              ]}
            />
          </div>
        </GenericModal>
      )}

      {modalSolicitudes.open && (
        <GenericModal
          open={modalSolicitudes.open}
          closeModal={() => {
            setModalSolicitudes(initModal);
          }}
          title={modalSolicitudes.title}
          gridStyle={{ textAlign: 'center', padding: '1em' }}
          maxWidth="sm"
        >
          <div style={{ border: '1px solid #ddd' }}>
            <GenericCheckboxTable
              ref={componentRef}
              data={modalSolicitudes.value.solicitudesUsuarios}
              selected={selected}
              setSelected={setSelected}
              withoutPagination
              align="center"
              colTitleStyle={{ fontSize: '1.2em' }}
              columns={[
                {
                  label: 'Nombre Usuario',
                  id: 'recepcionista.userName',
                },
                {
                  label: 'Fecha Solicitud',
                  customBody: (item) =>
                    moment(item.fechaSolicitud).format('DD/MM/YYYY'),
                },
              ]}
            />
            <ButtonGroupGeneric
              buttonList={[
                {
                  style: { borderRadius: 0 },
                  size: 'large',
                  type: 'button',
                  text: 'RECHAZAR',
                  fullWidth: true,
                  color: 'secondary',
                  disabled: selected.length === 0,
                  onClick: () => {
                    const recepcion = totem.data.recepciones.find(
                      (item) => item.id === modalSolicitudes.value.id,
                    );
                    totem.remove.solicitudesRecepcionesUsuario(
                      { solicitudes: selected.join(',') },
                      {
                        ...recepcion,
                        solicitudesUsuarios:
                          recepcion.solicitudesUsuarios.filter(
                            (su) => !selected.some((s) => s === su.id),
                          ),
                      },
                    );
                    setModalSolicitudes(initModal);
                  },
                },
                {
                  style: { borderRadius: 0 },
                  size: 'large',
                  type: 'button',
                  text: 'CONFIRMAR',
                  fullWidth: true,
                  disabled: selected.length === 0,
                  onClick: () => {
                    const recepcion = totem.data.recepciones.find(
                      (item) => item.id === modalSolicitudes.value.id,
                    );
                    const solicitudesUsuario =
                      recepcion.solicitudesUsuarios.filter((item) =>
                        selected.some((s) => s === item.id),
                      );
                    const recepcionistas = solicitudesUsuario.map(
                      (item) => item.recepcionista,
                    );
                    totem.update.solicitudesRecepcionesUsuario(
                      { solicitudes: selected.join(',') },
                      {
                        ...recepcion,
                        recepcionistas: [
                          ...recepcion.recepcionistas,
                          recepcionistas,
                        ],
                        solicitudesUsuarios:
                          recepcion.solicitudesUsuarios.filter(
                            (su) => !selected.some((s) => s === su.id),
                          ),
                      },
                    );
                    setModalSolicitudes(initModal);
                  },
                },
              ]}
            />
          </div>
        </GenericModal>
      )}
    </div>
  );
};
